import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import {
  CreateCurriculumRequest,
  CurriculumDto,
} from "../../interfaces/curriculum";

export type UpdateCurriculumRequest = Partial<CreateCurriculumRequest>;

export const curriculumApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurricula: builder.query<
      { data: CurriculumDto[]; meta: any },
      PaginateQuery
    >({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/curriculum"),
      }),
      providesTags: ["Paginated-Curricula"],
    }),
    getCurriculum: builder.query<CurriculumDto, string>({
      query: (id) => ({ url: `/api/curriculum/${id}` }),
      providesTags: ["Curriculum"],
    }),
    getCurriculumSelectList: builder.query<any, string | void>({
      query: (educationSystemId) => ({
        url: educationSystemId
          ? `/api/curriculum/select-list/all?educationSystemId=${educationSystemId}`
          : `/api/curriculum/select-list/all`,
      }),
      providesTags: ["Curriculum-Select-List"],
    }),
    addCurriculum: builder.mutation<any, CreateCurriculumRequest>({
      query: (data) => ({
        url: "/api/curriculum",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "Curriculum",
        "Curriculum-Select-List",
        "Paginated-Curricula",
      ],
    }),
    updateCurriculum: builder.mutation<
      any,
      { id: string; data: UpdateCurriculumRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/curriculum/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "Curriculum",
        "Curriculum-Select-List",
        "Paginated-Curricula",
      ],
    }),
    deleteCurriculum: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/curriculum/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Curriculum-Select-List", "Paginated-Curricula"],
    }),
  }),
});

export const {
  useGetCurriculaQuery,
  useGetCurriculumQuery,
  useGetCurriculumSelectListQuery,
  useAddCurriculumMutation,
  useUpdateCurriculumMutation,
  useDeleteCurriculumMutation,
} = curriculumApi;
